<template>
  <div class="conclude-session-modal">
    <h2>{{title}}</h2>
    <h4>{{description}} <span class="bold">{{session && session.title}}</span>?</h4>

     <form @submit.prevent="updateTitle">
          <div class="form-field">
            <label for="conclusion"><span class="bold">{{question}}</span></label>
            <div class="info">{{info}}</div>
            <textarea
              id="conclusion"
              v-model="conclusion"
              @input="mixin_autoResize_resize"
              @focus="mixin_autoResize_resize"
              :placeholder="placeholder"
            />
          </div>
          <div>
            <ima-button :title="concludeBtnLabel" :act="concludeSession"></ima-button>
          </div>
        </form>
  </div>
</template>

<script>
import mixinAutoResize from "../../mixins/autoResize.js";
import ImaButton from "@/components/shared/ImaButton.vue";

import concludeSession from "@/gql/lists/concludeSession.gql";

export default {
  components: { ImaButton },
  data() {
    return {
      title: "Conclude session",
      description: "Are you ready to conclude the brainstorming session for",
      question: "What is the outcome of the session?",
      info: "The conclusion will be shown in the brainstorming session page, and it will be visible to all participants.",
      placeholder: 'Write your conclusion here...',
      conclusion: '',
      concludeBtnLabel: "Conclude",
    }
  },
  props: {
    session: {
      type: Object,
    },
  },
  methods: {
    async concludeSession() {
      const { data } = await this.$apollo.mutate({
        mutation: concludeSession,
        variables: {
          listId: this.session.id,
          conclusion: this.conclusion
        }
      }).catch((e) => {
        this.$rollbar.error(e);
        alert("There was an error closing the session. Please try again later.");
      })
      if(data) {
        alert("The brainstorming session has been concluded successfully.");
      } else {
        alert("There has been a problem while trying to close the brainstorming session. Please try again later.");
      }
      this.$emit("close-modal");
    }
  },
  mounted() {
    this.conclusion = this.session.conclusion;
  },
  mixins: [mixinAutoResize]
}
</script>

<style scoped lang="scss">
@use '@/styles/theme.scss';

.page-title {
  margin-bottom: 40px;
}

form {
  margin-top: 40px;
}

.form-field {
  margin-bottom: 24px;
}

.form-field > * {
  display: block;
  border-color: theme.$text-color;
}

.primary-button {
  margin-top: top 30px;
  text-align: center;
}

textarea {
  border: 1px solid theme.$text-color;
  border-radius: 4px;
  padding: 6px 8px;
  width: 100%;
  outline: none;
  max-height: 140px;
  resize: vertical;
  font-size: 14px;
  font-weight: 200;
  min-height: 6em;
}
.info {
  font-size: 12px;
  color: theme.$text-secondary-color;
  margin-bottom: 8px;
}
label {
  margin-bottom: 0;
}
</style>